import { ConnectedComponentProps } from 'app/infrastructure/ui/types-uischema';

export const print = (caseState, uiEngineProps:ConnectedComponentProps) => {
  const hostprops = uiEngineProps.hostProps();

  return {
    print: hostprops && hostprops.print
  };
};
